// Texty a rozpoznávací pravidla modelu stránky/modalu servisu (serviceModel.js).
// Regexy čtou text a formátování z administrace (nadpisy sekcí, ceny, „Zdarma").
export default {
  eyebrow: 'Servisní středisko Jipos',
  spec: 'Specializace na:',
  pricePerex:
    'Ceny jsou orientační a platí jako „od". Konečnou cenu vám řekneme po diagnostice; v případě výměny dílu odpovídá cena ceně výměny.',
  bandTitle: 'Potřebujete opravit nářadí?',
  bandText: 'Napište nebo přineste nářadí na prodejnu v Bílině. Diagnostikujeme závadu a dopředu sdělíme cenu i termín.',

  // nadpisy sekcí v administraci
  headingServicesRe: /co nabízíme/i,
  headingPricingRe: /cen[íi]k/i,
  headingWhyRe: /proč/i,

  // „Specializujeme se … na námi prodávané značky: …"
  specializeRe: /speciali[sz]/i,

  // cena za položku servisu: „za cenu 199 Kč" / „od 70 Kč" / „cca 100 Kč" / „již od 1 200 Kč"
  priceWordRe: /\s*\b(?:(za\s+cenu|za|od|cca|již\s+od)\s+)(\d[\d\s]*K[čc])\.?$/i,
  wordFrom: 'od',
  wordAlreadyFrom: 'již od',
  wordCca: 'cca',
  prefixFrom: 'od ',
  prefixCca: 'cca ',
  // řádek ceníku „Název: 1 200 Kč (poznámka)" — cena bez „za cenu"/„za"/„již od"
  pricingValueRe: /(?:\b(od|cca)\s+)?(\d[\d\s]*K[čc])/i,

  // „… - ZDARMA"
  freeSuffixRe: /\s*[-–—:]\s*(zdarma)\.?$/i,
  freeLabel: 'Zdarma',

  // ikony podle klíčových slov v názvu položky (pořadí rozhoduje)
  serviceIcons: [
    [/diagnost/i, 'cog'],
    [/výměn/i, 'refresh'],
    [/brou[sš].*(nůž|nože)|nůž|nože/i, 'leaf'],
    [/brou[sš]|řet[eě]z/i, 'bolt'],
    [/údržb/i, 'wrench'],
    [/díl|oprav/i, 'package'],
    [/rad|tip/i, 'headset'],
  ],
  priceIcons: [
    [/sekač/i, 'leaf'],
    [/pil|křovinořez/i, 'bolt'],
    [/drtič|kultivátor|fréz/i, 'cog'],
  ],
  whyIcons: [
    [/rychl/i, 'bolt'],
    [/zkušen|prax/i, 'rosette'],
    [/záruk|kvalit/i, 'shield'],
    [/cen|poplat/i, 'tag'],
  ],
};
